
import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import currencyOptionMixin from '@/mixin/currencyOption'
import { AppModule } from '@/store/modules/app'
import {
  getUpstreamAccount,
  getUnlockAccount,
  setLockAccount,
  setReview
} from '@/api/product/subAccount'
import { getCurrentDate, dateToSeconds, pickerOptions } from '@/utils/dateTime'
import { delObjEmptyKey } from '@/utils'
import { getType } from '@/utils/cookies'
import { Form as ElForm } from 'element-ui'

const initDate = getCurrentDate()
@Component({
  name: 'productList',
  components: {}
})
export default class extends mixins(currencyOptionMixin) {
  queryForm: any = {
    currency: AppModule.currentCurrencyType,
    name: '',
    start_time: initDate[0],
    end_time: initDate[1],
    status: null,
    approve: null
  }

  @Watch('currentProduct')
  private wacthProduct() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }
  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  protected pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }
  private date: any[] = getCurrentDate()
  private pickerOptions: any = pickerOptions

  private promptLoading: boolean = false

  // 货币切换
  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 排序
  // private sortChange(column, prop, order) {
  //   // 点击排序按钮后拿到column.order，可以发送column.order给后台，后台再根据什么排序来返回排序过后的数据

  //   console.log(column + '---' + column.prop + '---' + column.order)
  //   if (!column.order) {
  //     let el:any = this.$refs.myTable
  //     el.clearSort()
  //   }
  //   if (column.prop === 'volume') {
  //     column.order === 'ascending' ? this.queryForm.sort_by = 'volume' : column.order === 'descending' ? this.queryForm.sort_by = '-volume' : this.queryForm.sort_by = null
  //   } else if (column.prop === 'success_amount') {
  //     column.order === 'ascending' ? this.queryForm.sort_by = 'success_amount' : column.order === 'descending' ? this.queryForm.sort_by = '-success_amount' : this.queryForm.sort_by = null
  //   }
  //   this.hadleGetFilesListApi()
  //   // 输出的结果 [object Object]---name---ascending
  // }

  // 对所有数据进行分页处理 发送请求
  private total = 0
  private accountList: any[] = []
  private async hadleGetFilesListApi() {
    try {
      this.promptLoading = true
      const params = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      // let data = delObjEmptyKey(params)
      await getUpstreamAccount(params).then((res: any) => {
        this.total = res.count
        this.accountList = res.results
        this.promptLoading = false
      })
    } catch (e) {
      this.promptLoading = false
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      currency: this.queryForm.currency,
      name: '',
      start_time: null,
      end_time: null,
      status: null
    }
    // let el:any = this.$refs.myTable
    // el.clearSort()
    this.currentPage = 1
    this.date = getCurrentDate()
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  // 解锁
  private async changeUnlock(row) {
    try {
      const data = {
        id: row.id,
        body: {
          unblock: true
        }
      }
      // let data = delObjEmptyKey(params)
      await getUnlockAccount(data).then((res: any) => {
        this.$message.success('Unlocking succeeded!')
        this.hadleGetFilesListApi()
      })
    } catch (e) {}
  }

  private async changeLock(row) {
    try {
      const data = {
        id: row.id,
        body: {
          block: true
        }
      }
      await setLockAccount(data).then((res: any) => {
        this.$message.success('Lock succeeded!')
        this.hadleGetFilesListApi()
      })
    } catch (e) {}
  }

  private reviewVisible: boolean = false
  private reviewInfo: any = {}
  private openReview(row) {
    this.queryForm.approve = null
    this.reviewInfo = row
    this.reviewVisible = true
  }
  private saveApprove() {
    ;(this.$refs.queryForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          let data = {
            id: this.reviewInfo.id,
            approve: this.queryForm.approve
          }
          await setReview(data).then((res: any) => {
            this.$message.success('Operation successful!')
            this.reviewVisible = false
            this.hadleGetFilesListApi()
          })
        } catch (e) {}
      } else {
        return false
      }
    })
  }

  private sysType: any = ''

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.hadleGetFilesListApi()
    this.sysType = getType()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.subAccount`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
